import { render, staticRenderFns } from "./redeemCode.vue?vue&type=template&id=6808397a&scoped=true&"
import script from "./redeemCode.vue?vue&type=script&lang=js&"
export * from "./redeemCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6808397a",
  null
  
)

export default component.exports